import i18next from "../../../../i18n";

i18next.addResourceBundle("en", "SustainabilityCenterTables", {
    title_controls: "Controls",
});

i18next.addResourceBundle("fr", "SustainabilityCenterTables", {
    title_controls: "Contrôles",
});
